import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { createTask } from '../logic/utils';
const InputField = ({ tasks, setTasks, taskLocation }) => {
    const [inputValue, setInputValue] = useState('');
    function handleAdd(event) {
        event.preventDefault();
        if (inputValue.length > 0) {
            createTask(inputValue, taskLocation)
                .then((createdTask) => setTasks([...tasks, createdTask].sort((a, b) => a.title.localeCompare(b.title))))
                .catch(() => alert('Inserting new task failed'));
            setInputValue('');
        }
    }
    return (_jsxs("form", { className: 'my-4 flex flex-row w-full gap-2', id: 'input', onSubmit: handleAdd, children: [_jsx("input", { type: 'input', value: inputValue, onChange: (e) => setInputValue(e.target.value), placeholder: 'Enter a to-do', className: 'todo-input-text' }), _jsx("button", { className: 'todo-input-button', type: 'submit', children: "GO" })] }));
};
export default InputField;
